import { render, staticRenderFns } from "./FormRadioThemes.vue?vue&type=template&id=70342da0&lang=html&"
import script from "./FormRadioThemes.vue?vue&type=script&lang=js&"
export * from "./FormRadioThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports